
import ApiHelper from '@/common/ApiHelper';
import { getAddressReturn, getSessonStorage, setCookie, setSessonStorage, getCookie } from '@/utils';
import { BFD_appGetGpsLoc, BFD_checkApp } from '@/utils/bfdApp';
import * as device from '@/utils/device';
import { TLang } from '@/utils/lang';

const api = new ApiHelper();

const MALLAPI_URL = process.env.MALLAPI_URL;
const APPAPI_URL = process.env.APPAPI_URL;
const locationUrl = {
  signature: APPAPI_URL + '/permission_valid_config/signature'
};
const locationApi = {

  /**
   * 查找工会浮标
  */
  findUnionBuoy(params) {
    return api.Post(
      APPAPI_URL + '/shopext/unionBuoy/findUnionBuoy',
      params
    );
  }
};
export default locationApi;
